import React, { FormHTMLAttributes } from 'react';

import {
    StandardFormActions,
    StandardFormWrapper,
} from './StandardForm.styled';

interface StandardFormProps extends FormHTMLAttributes<HTMLFormElement> {
    children: React.ReactNode;
    className?: string;
}

export const StandardForm = ({
    children,
    className,
    ...props
}: StandardFormProps) => (
    <StandardFormWrapper {...props} className={className}>
        {children}
    </StandardFormWrapper>
);

StandardForm.Actions = StandardFormActions;
